@use '@design/design-tokens/typography/typography' as *;

.chartLegendRoot {
  width: 100%;
  height: 24px;
  display: flex;
}

.legendItem {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
}

.legendIcon {
  margin-right: 6px;
}

.legendLabel {
  @include typography-v2-body-xs;
  color: var(--text-default);
}

.miniBar {
  width: 2px;
  height: 16px;
  border-radius: 2px;
  background-color: var(--border-success);
  border-bottom: 8px solid var(--border-critical);
  box-sizing: border-box;
}

.miniCircle {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  border: 1px solid #fff; /* stylelint-disable-line */
  background-color: var(--background-default);
}
